module.exports = __webpack_public_path__ + "static/img/tzywTitle.6d0d5c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tzywTitle.png
// module id = xxai
// module chunks = 2